import React from 'react'
import styled from 'styled-components'
import Mybadge from './Basics/Badge'
import { Paper, Chip, Typography, Badge } from '@material-ui/core'
import Tooltip from './Basics/Tooltip'
import PropTypes from 'prop-types'
import { capitalize } from '../modules/utils/helpers'
import moment from 'moment'
// eslint-disable-next-line
import { default as truckImg } from '../constants/images/truck.svg'
// eslint-disable-next-line
import { default as truckImgFront } from '../constants/images/front.svg'
// eslint-disable-next-line
import { default as truckOffImg } from '../constants/images/GroupTruckDisabled.svg'
// eslint-disable-next-line
import { default as truckFrontOffImg } from '../constants/images/frontOff.svg'
// eslint-disable-next-line
import { default as caexHalfFuelImg } from '../constants/images/caex_half_fuel.svg'
// eslint-disable-next-line
import { default as gas } from '../constants/icons/gasStation.svg'
// eslint-disable-next-line
import { default as gasStation } from '../constants/icons/gasStationFill.svg'
// eslint-disable-next-line
import { default as symbology8Out } from '../constants/icons/tankSymbology8.svg'
// eslint-disable-next-line
import { default as camionAAbastecer } from '../constants/images/camion_a_abastecer.svg'

const SOURCE_LABELS = {
  orpak: 'Fluidintel',
  dispatch: 'FMSDiesel'
}

// `source` llega del websocket como "orpak" / "dispatch", pero cuando el ADS se arma sin GPS
// (caída de la fuente GPS del cliente) el backend manda 0 en vez de texto. Cualquier cosa que no
// sea un string no vacío se muestra como «—» en lugar de botar la vista completa.
const getSourceLabel = source => {
  const key = typeof source === 'string' ? source.trim().toLowerCase() : ''
  if (!key) return '—'
  return SOURCE_LABELS[key] || capitalize(key)
}

// Forced blue + blinking background for the % badge when urgencia_combustible === 'alta'. MUI's
// own "secondary" badge color doesn't give us blue here, so we override .MuiBadge-badge directly
// with !important (ties with MUI's own color classes otherwise). The animation targets only the
// small floating badge pill, not .MuiBadge-root — which also wraps the patent Chip — so only the
// % pill blinks, not the whole thing. Reuses the "flash" keyframes from animate.css (loaded
// globally in public/index.html) instead of the animate__* classes, since those apply to the
// element they're set on and Badge's className prop lands on .MuiBadge-root, not .MuiBadge-badge.
const UrgentFuelBadge = styled(Badge)`
  & .MuiBadge-badge {
    background-color: #0047ce !important;
    color: #ffffff !important;
    animation: flash 1s ease-in-out infinite;
  }
`

const TruckVehicle = ({ truckData, color }) => {
  const [, setAnchorEl] = React.useState(null)
  const [, setOpen] = React.useState(false)
  const [placement, setPlacement] = React.useState()
  // const [style, setStyle] = useState({color: 'white', backgroundColor: color});
  // const [variant, setVariant] = useState('default');

  let variant = 'default'
  let style = {}
  // eslint-disable-next-line
  let icon = ''
  let hiddenBadge = false
  let truck = ''
  const optionTooltip = 'connected'

  const onHover = newPlacement => event => {
    setAnchorEl(event.currentTarget)
    setOpen(prev => placement !== newPlacement || !prev)
    setPlacement(newPlacement)
  }

  const tooltipTruck = (option, truckData) => {
    const now = moment()
    const lastCharge = truckData.last_charge_day + ' ' + truckData.last_charge_hour
    const lastChargeTime = moment(lastCharge, 'DD/MM/YYYY HH:mm:ss')
    const daysDiff = now.diff(lastChargeTime, 'days')
    const hoursDiff = now.diff(lastChargeTime, 'hours')
    const pluralDay = daysDiff > 1 ? ' días' : ' día'
    const pluralHour = hoursDiff <= 1 ? ' hora' : ' horas'
    const lastChargeString = daysDiff > 0 ? 'Hace ' + daysDiff + pluralDay : 'Hace ' + hoursDiff + pluralHour
    const lastChargeStation =
      truckData.charge_station && truckData.charge_station.length > 0
        ? 'Lugar de abastecimiento: ' + truckData.charge_station[0]
        : ''
    switch (option) {
      default:
        return (
          <>
            <Paper style={{ padding: 10, color: 'white', background: 'black' }}>
              <Typography style={{ fontSize: 12 }}>
                <strong>{'Camión: ' + truckData.patent}</strong>
                <br />
                <span>
                  Nivel de combustible: <b>{Math.round(truckData.percent)} %</b> -
                </span>
                {/* 'Nivel de combustible: ' + Math.round(truckData.percent) + '% -' */}
                <br />
                <span>
                  Tasa de consumo: <b>{Math.round(truckData.fuel_rate)} L/H</b> en el último ciclo -
                </span>
                <br />
                {truckData.horas_hasta_carga !== null && (
                  <>
                    <span>
                      Tiempo estimado hasta abastecimiento: <b>{truckData.horas_hasta_carga.toFixed(1)} horas</b> -
                    </span>
                    <br />
                  </>
                )}
                <span>
                  <b>{Math.round(truckData.fuel_level)}</b> litros en estanque.
                </span>
                {/* Math.round(truckData.fuel_level) + ' litros en estanque.' */}
                <br />
                <span>
                  Última carga: <b>{lastChargeString}</b> -
                </span>
                {/* 'Última carga: ' + lastChargeString */}
                <br />
                Cantidad litros última carga: {truckData.truck_last_charge}
                <br />
                {truckData.last_charge_day + ' a las ' + truckData.last_charge_hour + '.'}
                <br />
                {lastChargeStation}
                <br />
                Fuente: {getSourceLabel(truckData.source)}
              </Typography>
            </Paper>
          </>
        )
    }
  }

  const renderTruck = (optionTooltip, truckData) => {
    const isPartialCharge = [true, 1, '1', 'True', 'true'].includes(truckData.ultima_carga_parcial)
    const sendToFueling = [true, 1, '1'].includes(truckData.enviar_a_carga)
    const hoursToFueling = truckData.horas_hasta_carga
    const isUrgentFuel = truckData.urgencia_combustible === 'alta'
    // if (truckData.disconnected_sources) {
    //   icon = offline;
    //   hiddenBadge = false;
    //   optionTooltip = 'anyDisconnected';
    // }
    // if (truckData.all_disconnected_sources) {
    //   icon = cloudOff;
    //   hiddenBadge = false;
    //   optionTooltip = 'allDisconnected';
    // }
    // if (truckData.loading) {
    //   icon = sync;
    //   hiddenBadge = false;
    //   optionTooltip = 'sync';
    // }

    // set truck active status
    if (truckData.active) {
      truck = truckData.percent < 25 ? truckImgFront : truckImg
    } else {
      truck = truckData.percent < 25 ? truckFrontOffImg : truckOffImg
    }

    if (isPartialCharge) {
      truck = caexHalfFuelImg
    }

    if (truckData.percent < 25) {
      icon = symbology8Out
      hiddenBadge = false
    }

    // set truck supply assignment tooltip
    if (truckData.go_supply) {
      optionTooltip = 'goSupply'
      hiddenBadge = false
      // hiddenBadge = false
      // icon = gasStation
    }

    if (truckData.active && truckData.go_supply) {
      style = { color: 'rgb(51, 51, 51)', borderColor: 'rgb(51, 51, 51)', backgroundColor: 'transparent' }
      variant = 'outlined'
    } else if (!truckData.active && truckData.go_supply) {
      style = { color: '#BDBDBD' }
    } else if (truckData.active && !truckData.go_supply) {
      variant = 'outlined'
      style = { color: color, borderColor: color }
    } else if (!truckData.active && !truckData.go_supply) {
      variant = 'outlined'
      style = { color: '#BDBDBD', borderColor: '#BDBDBD' }
      optionTooltip = 'disconnected'
    }

    // none of the trucks in the last truck show badges or different colors
    if (truckData.percent >= 50) {
      hiddenBadge = false
      variant = 'outlined'
      style = { color: 'rgb(51, 51, 51)', borderColor: 'rgb(51, 51, 51)', backgroundColor: 'transparent' }
    }

    // // asignado a abastecimiento
    // if (truckData.active && truckData.go_supply) {
    //   variant = "default";
    //   style = { color: 'white', backgroundColor: color };
    //   // truck = bounceTruck;
    //   truck = truckImg;
    //   optionTooltip = 'goSupply';
    //   icon = gasStation;
    //   hiddenBadge = false;
    // }

    // // asignado a abastecimiento y no activo
    // if (!truckData.active && truckData.go_supply) {
    //   variant = "default";
    //   style = { color: '#BDBDBD' };
    //   truck = truckOffImg;
    //   optionTooltip = 'goSupply';
    //   icon = gasStation;
    //   hiddenBadge = false;
    // }

    // if (truckData.active && !truckData.go_supply) {
    //   variant = "outlined";
    //   style = { color: color, borderColor: color };
    //   truck = truckImg;
    // }

    // //Ciclo extenso de combustible
    // if (!truckData.active && !truckData.go_supply) {
    //   variant = "outlined";
    //   style = { color: '#BDBDBD', borderColor: '#BDBDBD' };
    //   truck = truckOffImg;
    //   optionTooltip = 'disconnected';
    // }
    const badgePercentage = (isPartialCharge ? '~' : '') + Math.round(truckData.percent) + '%'
    const PercentBadge = isUrgentFuel ? UrgentFuelBadge : Badge
    const percentBadgeContent = isUrgentFuel ? (
      <span style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src={camionAAbastecer}
          alt="enviar a abastecer"
          style={{ height: '10px', width: 'auto', display: 'block', filter: 'brightness(0) invert(1)' }}
        />
        {badgePercentage}
      </span>
    ) : (
      badgePercentage
    )
    const isAnimated =
      truckData.percent < 25 || isPartialCharge || sendToFueling
        ? 'animate__animated animate__flash animate__infinite infinite'
        : ''
    const badgeColorDistance = () => {
      const distanceGps = truckData.distancia_gps
      if (distanceGps < 180) {
        return 'primary'
      } else if ((distanceGps >= 180) & (distanceGps < 205)) {
        return 'secondary'
      } else if (distanceGps >= 205) {
        return 'error'
      }
    }

    const badgeColorTime = () => {
      const timeOn = truckData.t_encendido
      if (timeOn < 17.5) {
        return 'primary'
      } else if ((timeOn >= 17.5) & (timeOn < 20)) {
        return 'secondary'
      } else if (timeOn >= 20) {
        return 'error'
      }
    }

    return (
      <>
        <div
          onMouseOver={onHover('bottom')}
          onMouseOut={() => {
            setOpen(false)
          }}
        >
          <Mybadge
            color={sendToFueling ? 'error' : 'primary'}
            invisible={hoursToFueling === null && !sendToFueling}
            badgeContent={
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <img
                  src={gasStation}
                  alt="horas hasta abastecimiento"
                  style={{ width: '12px', height: '12px', display: 'block', filter: 'brightness(0) invert(1)' }}
                />
                {hoursToFueling !== null && `${hoursToFueling.toFixed(1)}h`}
              </span>
            }
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
          >
            <PercentBadge invisible={hiddenBadge} color="secondary" badgeContent={percentBadgeContent}>
              <Tooltip content={tooltipTruck(optionTooltip, truckData)} arrow>
                <Chip
                  variant={variant}
                  style={{ ...style, marginLeft: '10px', marginTop: '5px' }}
                  size="small"
                  label={truckData.patent}
                />
              </Tooltip>
            </PercentBadge>
          </Mybadge>
          {/* <Tooltip title={tooltipTruck(optionTooltip, truckData)} arrow={true}>
            <Chip
              variant={variant}
              style={{ ...style, marginLeft: '10px' }}
              size="small"
              label={truckData.patent}
            />

          </Tooltip> */}
          <div className={isAnimated}>
            <Mybadge
              color="error"
              invisible={!isPartialCharge}
              badgeContent="½"
              anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
              <Mybadge
                color={badgeColorTime()}
                badgeContent={`${truckData.t_encendido}h`}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                max={25}
              >
                <Mybadge
                  color={badgeColorDistance()}
                  badgeContent={`${truckData.distancia_gps}km`}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  max={300}
                >
                  <img
                    src={truck}
                    alt={truckData.patent}
                    style={{ width: '6vh', height: '3.08vh', objectFit: 'cover' }}
                  />
                </Mybadge>
              </Mybadge>
            </Mybadge>
          </div>
        </div>
      </>
    )

    // if (truckData.active) {
    //   if (truckData.dataLoss) {
    //     // truck with data loss
    //     return(
    //       <div onMouseOver={onHover('bottom')} onMouseOut={()=>{setOpen(false)}}>
    //         <Chip
    //           variant={open ? "default":"outlined"}
    //           style={open ? {color:'white', backgroundColor:color} : {color: color, borderColor: color}}
    //           size="small"
    //           label={truckData.patent} />
    //         <div className={'animate__animated animate__flash animate__infinite infinite animate__slower'}><img src={truckImg} alt={truckData.patent} style={{width:'45px'}}/></div>
    //       </div>
    //     )
    //   } else {
    //     // truck active
    //     return(
    //       <div onMouseOver={onHover('bottom')} onMouseOut={()=>{setOpen(false)}}>
    //         <Chip
    //           variant={open ? "default":"outlined"}
    //           style={open ? {color:'white', backgroundColor:color} : {color: color, borderColor: color}}
    //           size="small"
    //           label={truckData.patent}
    //         />
    //         <div><img src={truckImg} alt={truckData.patent} style={{width:'45px'}}/></div>
    //       </div>
    //     )
    //   }
    // } else {
    //   // truck inactive
    //   return(
    //     <div onMouseOver={onHover('bottom')} onMouseOut={()=>{setOpen(false)}}>
    //       <Chip
    //         variant={open ? "default":"outlined"}
    //         style={open ? {color:'white', backgroundColor:color} : {color: color, borderColor: color}}
    //         size="small"
    //         label={truckData.patent}
    //         disabled={true} />
    //       <div><img src={truckOffImg} alt={truckData.patent} style={{width:'45px'}}/></div>
    //     </div>
    //   )
    // }
  }

  return (
    <div style={{ paddingLeft: '6%', paddingTop: '3%' }}>
      {renderTruck(optionTooltip, truckData)}
      {/* <Popper
        open={open}
        anchorEl={anchorEl}
        placement={placement}
        transition
      >
        {tooltipTruck(optionTooltip, truckData)}
      </Popper> */}
    </div>
  )
}

TruckVehicle.propTypes = {
  truckData: PropTypes.object,
  color: PropTypes.string
}

export default TruckVehicle
